/**
 * Amount of milliseconds in a second.
 */
var MS_SECOND = 1000;
/**
 * Amount of milliseconds in a minute.
 */
var MS_MINUTE = 60000;
/**
 * Amount of milliseconds in an hour.
 */
var MS_HOUR = 3600000;
/**
 * Amount of milliseconds in a day.
 */
var MS_DAY = 86400000;

/**
 * Returns the duration in milliseconds.
 *
 * @param ms the amount of milliseconds
 * @param s the amount of seconds
 * @param m the amount of minutes
 * @param h the amount of hours
 * @param d the amount of days
 */
function of(ms, s, m, h, d) {
    ms = ms || 0;
    s = s || 0;
    m = m || 0;
    h = h || 0;
    d = d || 0;
    return ms + s * MS_SECOND + m * MS_MINUTE + h * MS_HOUR + d * MS_DAY;
}
/**
 * Returns the duration from seconds.
 *
 * @param seconds
 */
function fromSeconds(seconds) {
    return seconds * MS_SECOND;
}
/**
 * Returns the duration from minutes.
 *
 * @param minutes
 */
function fromMinutes(minutes) {
    return minutes * MS_MINUTE;
}
/**
 * Returns the duration from hours.
 *
 * @param hours
 */
function fromHours(hours) {
    return hours * MS_HOUR;
}
/**
 * Returns the duration from days.
 *
 * @param days
 */
function fromDays(days) {
    return days * MS_DAY;
}
/**
 * Gets the duration between 2 dates.
 *
 * @param left the first date
 * @param right
 */
function between(left, right) {
    if (left instanceof Date === false) {
        throw new TypeError('Both arguments passed to between must be actual Date instances, but the first one was not.');
    }
    if (right instanceof Date === false) {
        throw new TypeError('Both arguments passed to between must be actual Date instances, but the second one was not.');
    }
    return right.getTime() - left.getTime();
}

/**
 * Gets the millisecond component of a duration.
 *
 * @param duration
 */
function getMilliseconds(duration) {
    return duration % 1000;
}
/**
 * Gets the second component of a duration.
 *
 * @param duration
 */
function getSeconds(duration) {
    return Math.floor(duration / MS_SECOND) % 60;
}
/**
 * Gets the minute component of a duration.
 *
 * @param duration
 */
function getMinutes(duration) {
    return Math.floor(duration / MS_MINUTE) % 60;
}
/**
 * Gets the hour component of a duration.
 *
 * @param duration
 */
function getHours(duration) {
    return Math.floor(duration / MS_HOUR) % 24;
}
/**
 * Gets the day component of a duration.
 *
 * @param duration
 */
function getDays(duration) {
    return Math.floor(duration / MS_DAY);
}
/**
 * Gets the duration in seconds.
 *
 * @param duration
 */
function getTotalSeconds(duration) {
    return duration / MS_SECOND;
}
/**
 * Gets the duration in minutes.
 *
 * @param duration
 */
function getTotalMinutes(duration) {
    return duration / MS_MINUTE;
}
/**
 * Gets the duration in hours.
 *
 * @param duration
 */
function getTotalHours(duration) {
    return duration / MS_HOUR;
}
/**
 * Gets the duration in days.
 *
 * @param duration
 */
function getTotalDays(duration) {
    return duration / MS_DAY;
}

/**
 * Formats a duration as a string.
 *
 * @param duration
 */
function format(duration) {
    var abs = Math.abs(duration);
    var isNegative = abs !== duration;
    var days = getDays(abs);
    var hours = getHours(abs);
    var minutes = getMinutes(abs);
    var seconds = getSeconds(abs);
    var milliseconds = getMilliseconds(abs);
    var result = padNumber(hours) + ":" + padNumber(minutes) + ":" + padNumber(seconds);
    // Only displays the milliseconds portion is there is one.
    if (milliseconds !== 0) {
        result += "." + padNumber(milliseconds, 3);
    }
    // Only displays the days portion is there is one.
    if (days !== 0) {
        result = days + " " + result;
    }
    // Negative durations need a prefix.
    if (isNegative) {
        result = '-' + result;
    }
    return result;
}
/**
 * Pads a number with extra zeroes if needed.
 *
 * @param n
 */
function padNumber(n, amount) {
    if (amount === void 0) { amount = 2; }
    var s = n.toString();
    return '0'.repeat(amount - s.length) + s;
}

export { MS_DAY, MS_HOUR, MS_MINUTE, MS_SECOND, between, format, fromDays, fromHours, fromMinutes, fromSeconds, getDays, getHours, getMilliseconds, getMinutes, getSeconds, getTotalDays, getTotalHours, getTotalMinutes, getTotalSeconds, of };
